export const initialAuthState = {
  isAuthenticated: false,
  error: undefined,
  user: undefined,
  isLoading: true,
};
